import type { FileUIPart } from 'ai';

import {
  MAX_ATTACHMENTS,
  MAX_DOCUMENT_BYTES,
  MAX_IMAGE_BYTES,
  MAX_TOTAL_ATTACHMENT_BYTES,
} from '../constants';

const readAsDataUrl = (file: File): Promise<string> =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export const filesWithinUploadLimits = (files: File[]): boolean =>
  files.length <= MAX_ATTACHMENTS &&
  files.every(
    file =>
      file.size <=
      (file.type.startsWith('image/') ? MAX_IMAGE_BYTES : MAX_DOCUMENT_BYTES)
  ) &&
  files.reduce((total, file) => total + file.size, 0) <=
    MAX_TOTAL_ATTACHMENT_BYTES;

/** The chat request carries attachments inline, so picked files travel as data URLs. */
export const toFileParts = async (files: File[]): Promise<FileUIPart[]> => {
  if (!filesWithinUploadLimits(files)) {
    throw new Error('Attachment limit exceeded');
  }

  return Promise.all(
    files.map(async file => ({
      type: 'file' as const,
      filename: file.name,
      mediaType: file.type,
      url: await readAsDataUrl(file),
    }))
  );
};
